var r={SUCCESS:"success",ERROR:"error",INFO:"info",WARNING:"warning"};export{r as S};
